import React from "react";
import { trackTelegramClick } from "../../../lib/tracking";

const TELEGRAM_URL = "https://t.me/+T9sPHsLExsUxOTFk";

export default function FloatingLiveCta() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 flex justify-center px-4 pb-4 pointer-events-none sm:inset-x-auto sm:right-6 sm:bottom-6 sm:p-0">
      <a
        href={TELEGRAM_URL}
        onClick={() => trackTelegramClick("vsl_pulsante_fisso")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-live-cta"
        className="v-btn v-btn-blue btn-glow pointer-events-auto w-full sm:w-auto"
        style={{ borderRadius: 999, fontWeight: 700, padding: "10px 28px", textDecoration: "none" }}
      >
        <span className="relative flex h-2.5 w-2.5 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-70" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
        </span>
        <span className="flex flex-col items-center text-center" style={{ lineHeight: 1.25, fontFamily: "'Instrument Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji'" }}>
          <span data-testid="floating-live-cta-line1" style={{ fontSize: 16 }}>🎙️ Free Live Session 👇</span>
          <span data-testid="floating-live-cta-line2" style={{ fontSize: 14, fontWeight: 600 }}>🗓️ Ogni Lunedì ore 20:00 🕗</span>
        </span>
      </a>
    </div>
  );
}
